/* AUTO-GENERATED — do not edit. Generated by scripts/generate-currency-metadata.mjs from @fawazahmed0/currency-api (pinned dev-only codegen input) + scripts/currency-overrides.json. */
import type { CurrencyRecord } from './currency-metadata';

export const CURRENCY_LIST: CurrencyRecord[] = [
  {
    "code": "1INCH",
    "name": "1inch",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "AAVE",
    "name": "Aave",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ADA",
    "name": "Cardano",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "cardano"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "AED",
    "name": "Emirati Dirham",
    "symbol": "د.إ",
    "countryCode": "ae",
    "country": "United Arab Emirates",
    "aliases": [
      "dirham",
      "emirates",
      "emirati",
      "emiratidirham",
      "uae"
    ],
    "flagClass": "currency-flag currency-flag-ae",
    "kind": "fiat"
  },
  {
    "code": "AFN",
    "name": "Afghan Afghani",
    "symbol": null,
    "countryCode": "af",
    "country": "Afghanistan",
    "aliases": [
      "afghan",
      "afghanafghani",
      "afghani"
    ],
    "flagClass": "currency-flag currency-flag-af",
    "kind": "fiat"
  },
  {
    "code": "AKT",
    "name": "Akash Network",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "akash",
      "akashnetwork",
      "network"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ALGO",
    "name": "Algorand",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "algorand"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ALL",
    "name": "Albanian Lek",
    "symbol": null,
    "countryCode": "al",
    "country": "Albania",
    "aliases": [
      "albanian",
      "albanianlek",
      "lek"
    ],
    "flagClass": "currency-flag currency-flag-al",
    "kind": "fiat"
  },
  {
    "code": "AMD",
    "name": "Armenian Dram",
    "symbol": null,
    "countryCode": "am",
    "country": "Armenia",
    "aliases": [
      "armenian",
      "armeniandram",
      "dram"
    ],
    "flagClass": "currency-flag currency-flag-am",
    "kind": "fiat"
  },
  {
    "code": "AMP",
    "name": "Amp",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ANG",
    "name": "Dutch Guilder",
    "symbol": null,
    "countryCode": "cw",
    "country": "Curacao",
    "aliases": [
      "dutch",
      "dutchguilder",
      "guilder"
    ],
    "flagClass": "currency-flag currency-flag-cw",
    "kind": "fiat"
  },
  {
    "code": "AOA",
    "name": "Angolan Kwanza",
    "symbol": null,
    "countryCode": "ao",
    "country": "Angola",
    "aliases": [
      "angolan",
      "angolankwanza",
      "kwanza"
    ],
    "flagClass": "currency-flag currency-flag-ao",
    "kind": "fiat"
  },
  {
    "code": "APE",
    "name": "ApeCoin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "apecoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "APT",
    "name": "Aptos",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "aptos"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "AR",
    "name": "Arweave",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "arweave"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ARB",
    "name": "Arbitrum",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "arbitrum"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ARS",
    "name": "Argentine Peso",
    "symbol": "$",
    "countryCode": "ar",
    "country": "Argentina",
    "aliases": [
      "argentine",
      "argentinepeso",
      "peso"
    ],
    "flagClass": "currency-flag currency-flag-ar",
    "kind": "fiat"
  },
  {
    "code": "ATOM",
    "name": "Cosmos",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "cosmos"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ATS",
    "name": "Austrian Schilling",
    "symbol": null,
    "countryCode": "at",
    "country": "Austria",
    "aliases": [
      "austrian",
      "austrianschilling",
      "schilling"
    ],
    "flagClass": "currency-flag currency-flag-at",
    "kind": "fiat"
  },
  {
    "code": "AUD",
    "name": "Australian Dollar",
    "symbol": "A$",
    "countryCode": "au",
    "country": "Australia",
    "aliases": [
      "australia",
      "australian",
      "australiandollar",
      "dollar"
    ],
    "flagClass": "currency-flag currency-flag-au",
    "kind": "fiat"
  },
  {
    "code": "AVAX",
    "name": "Avalanche",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "avalanche"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "AWG",
    "name": "Aruban or Dutch Guilder",
    "symbol": null,
    "countryCode": "aw",
    "country": "Aruba",
    "aliases": [
      "aruban",
      "arubanordutchguilder",
      "dutch",
      "guilder",
      "or"
    ],
    "flagClass": "currency-flag currency-flag-aw",
    "kind": "fiat"
  },
  {
    "code": "AXS",
    "name": "Axie Infinity",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "axie",
      "axieinfinity",
      "infinity"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "AZM",
    "name": "Azerbaijani Manat",
    "symbol": null,
    "countryCode": "az",
    "country": "Azerbaijan",
    "aliases": [
      "azerbaijani",
      "azerbaijanimanat",
      "manat"
    ],
    "flagClass": "currency-flag currency-flag-az",
    "kind": "fiat"
  },
  {
    "code": "AZN",
    "name": "Azerbaijan Manat",
    "symbol": "₼",
    "countryCode": "az",
    "country": "Azerbaijan",
    "aliases": [
      "azerbaijan",
      "azerbaijanmanat",
      "manat"
    ],
    "flagClass": "currency-flag currency-flag-az",
    "kind": "fiat"
  },
  {
    "code": "BAKE",
    "name": "BakeryToken",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "bakerytoken"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "BAM",
    "name": "Bosnian Convertible Mark",
    "symbol": null,
    "countryCode": "ba",
    "country": "Bosnia and Herzegovina",
    "aliases": [
      "bosnian",
      "bosnianconvertiblemark",
      "convertible",
      "mark"
    ],
    "flagClass": "currency-flag currency-flag-ba",
    "kind": "fiat"
  },
  {
    "code": "BAT",
    "name": "Basic Attention Token",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "attention",
      "basic",
      "basicattentiontoken",
      "token"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "BBD",
    "name": "Barbadian or Bajan Dollar",
    "symbol": null,
    "countryCode": "bb",
    "country": "Barbados",
    "aliases": [
      "bajan",
      "barbadian",
      "barbadianorbajandollar",
      "dollar",
      "or"
    ],
    "flagClass": "currency-flag currency-flag-bb",
    "kind": "fiat"
  },
  {
    "code": "BCH",
    "name": "Bitcoin Cash",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "bitcoin",
      "bitcoincash",
      "cash"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "BDT",
    "name": "Bangladeshi Taka",
    "symbol": "৳",
    "countryCode": "bd",
    "country": "Bangladesh",
    "aliases": [
      "bangladeshi",
      "bangladeshitaka",
      "taka"
    ],
    "flagClass": "currency-flag currency-flag-bd",
    "kind": "fiat"
  },
  {
    "code": "BEF",
    "name": "Belgian Franc",
    "symbol": null,
    "countryCode": "be",
    "country": "Belgium",
    "aliases": [
      "belgian",
      "belgianfranc",
      "franc"
    ],
    "flagClass": "currency-flag currency-flag-be",
    "kind": "fiat"
  },
  {
    "code": "BGN",
    "name": "Bulgarian Lev",
    "symbol": "лв",
    "countryCode": "bg",
    "country": "Bulgaria",
    "aliases": [
      "bulgarian",
      "bulgarianlev",
      "lev"
    ],
    "flagClass": "currency-flag currency-flag-bg",
    "kind": "fiat"
  },
  {
    "code": "BHD",
    "name": "Bahraini Dinar",
    "symbol": ".د.ب",
    "countryCode": "bh",
    "country": "Bahrain",
    "aliases": [
      "bahraini",
      "bahrainidinar",
      "dinar"
    ],
    "flagClass": "currency-flag currency-flag-bh",
    "kind": "fiat"
  },
  {
    "code": "BIF",
    "name": "Burundian Franc",
    "symbol": null,
    "countryCode": "bi",
    "country": "Burundi",
    "aliases": [
      "burundian",
      "burundianfranc",
      "franc"
    ],
    "flagClass": "currency-flag currency-flag-bi",
    "kind": "fiat"
  },
  {
    "code": "BMD",
    "name": "Bermudian Dollar",
    "symbol": null,
    "countryCode": "bm",
    "country": "Bermuda",
    "aliases": [
      "bermudian",
      "bermudiandollar",
      "dollar"
    ],
    "flagClass": "currency-flag currency-flag-bm",
    "kind": "fiat"
  },
  {
    "code": "BNB",
    "name": "Binance Coin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "binance",
      "binancecoin",
      "coin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "BND",
    "name": "Bruneian Dollar",
    "symbol": null,
    "countryCode": "bn",
    "country": "Brunei",
    "aliases": [
      "bruneian",
      "bruneiandollar",
      "dollar"
    ],
    "flagClass": "currency-flag currency-flag-bn",
    "kind": "fiat"
  },
  {
    "code": "BOB",
    "name": "Bolivian Bolíviano",
    "symbol": null,
    "countryCode": "bo",
    "country": "Bolivia",
    "aliases": [
      "bol",
      "bolivian",
      "bolivianbolviano",
      "viano"
    ],
    "flagClass": "currency-flag currency-flag-bo",
    "kind": "fiat"
  },
  {
    "code": "BRL",
    "name": "Brazilian Real",
    "symbol": "R$",
    "countryCode": "br",
    "country": "Brazil",
    "aliases": [
      "brazilian",
      "brazilianreal",
      "real"
    ],
    "flagClass": "currency-flag currency-flag-br",
    "kind": "fiat"
  },
  {
    "code": "BSD",
    "name": "Bahamian Dollar",
    "symbol": null,
    "countryCode": "bs",
    "country": "Bahamas",
    "aliases": [
      "bahamian",
      "bahamiandollar",
      "dollar"
    ],
    "flagClass": "currency-flag currency-flag-bs",
    "kind": "fiat"
  },
  {
    "code": "BSV",
    "name": "Bitcoin SV",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "bitcoin",
      "bitcoinsv",
      "sv"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "BSW",
    "name": "Biswap",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "biswap"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "BTC",
    "name": "Bitcoin",
    "symbol": "₿",
    "countryCode": null,
    "aliases": [
      "bitcoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "BTCB",
    "name": "Bitcoin BEP2",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "bep2",
      "bitcoin",
      "bitcoinbep2"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "BTG",
    "name": "Bitcoin Gold",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "bitcoin",
      "bitcoingold",
      "gold"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "BTN",
    "name": "Bhutanese Ngultrum",
    "symbol": null,
    "countryCode": "bt",
    "country": "Bhutan",
    "aliases": [
      "bhutanese",
      "bhutanesengultrum",
      "ngultrum"
    ],
    "flagClass": "currency-flag currency-flag-bt",
    "kind": "fiat"
  },
  {
    "code": "BTT",
    "name": "BitTorrent",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "bittorrent"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "BUSD",
    "name": "Binance USD",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "binance",
      "binanceusd",
      "usd"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "BWP",
    "name": "Botswana Pula",
    "symbol": null,
    "countryCode": "bw",
    "country": "Botswana",
    "aliases": [
      "botswana",
      "botswanapula",
      "pula"
    ],
    "flagClass": "currency-flag currency-flag-bw",
    "kind": "fiat"
  },
  {
    "code": "BYN",
    "name": "Belarusian Ruble",
    "symbol": null,
    "countryCode": "by",
    "country": "Belarus",
    "aliases": [
      "belarusian",
      "belarusianruble",
      "ruble"
    ],
    "flagClass": "currency-flag currency-flag-by",
    "kind": "fiat"
  },
  {
    "code": "BYR",
    "name": "Belarusian Ruble",
    "symbol": null,
    "countryCode": "by",
    "country": "Belarus",
    "aliases": [
      "belarusian",
      "belarusianruble",
      "ruble"
    ],
    "flagClass": "currency-flag currency-flag-by",
    "kind": "fiat"
  },
  {
    "code": "BZD",
    "name": "Belizean Dollar",
    "symbol": null,
    "countryCode": "bz",
    "country": "Belize",
    "aliases": [
      "belizean",
      "belizeandollar",
      "dollar"
    ],
    "flagClass": "currency-flag currency-flag-bz",
    "kind": "fiat"
  },
  {
    "code": "CAD",
    "name": "Canadian Dollar",
    "symbol": "C$",
    "countryCode": "ca",
    "country": "Canada",
    "aliases": [
      "canada",
      "canadian",
      "canadiandollar",
      "dollar"
    ],
    "flagClass": "currency-flag currency-flag-ca",
    "kind": "fiat"
  },
  {
    "code": "CAKE",
    "name": "PancakeSwap",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "pancakeswap"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "CDF",
    "name": "Congolese Franc",
    "symbol": null,
    "countryCode": "cd",
    "country": "DR Congo",
    "aliases": [
      "congolese",
      "congolesefranc",
      "franc"
    ],
    "flagClass": "currency-flag currency-flag-cd",
    "kind": "fiat"
  },
  {
    "code": "CELO",
    "name": "Celo",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "CFX",
    "name": "Conflux",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "conflux"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "CHF",
    "name": "Swiss Franc",
    "symbol": "CHF",
    "countryCode": "ch",
    "country": "Switzerland",
    "aliases": [
      "franc",
      "swiss",
      "swissfranc",
      "switzerland"
    ],
    "flagClass": "currency-flag currency-flag-ch",
    "kind": "fiat"
  },
  {
    "code": "CHZ",
    "name": "Chiliz",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "chiliz"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "CLP",
    "name": "Chilean Peso",
    "symbol": "$",
    "countryCode": "cl",
    "country": "Chile",
    "aliases": [
      "chilean",
      "chileanpeso",
      "peso"
    ],
    "flagClass": "currency-flag currency-flag-cl",
    "kind": "fiat"
  },
  {
    "code": "CNH",
    "name": "Chinese Yuan Renminbi Offshore",
    "symbol": null,
    "countryCode": "cn",
    "country": "China",
    "aliases": [
      "chinese",
      "chineseyuanrenminbioffshore",
      "offshore",
      "renminbi",
      "yuan"
    ],
    "flagClass": "currency-flag currency-flag-cn",
    "kind": "fiat"
  },
  {
    "code": "CNY",
    "name": "Chinese Yuan Renminbi",
    "symbol": "¥",
    "countryCode": "cn",
    "country": "China",
    "aliases": [
      "china",
      "chinese",
      "chineseyuanrenminbi",
      "renminbi",
      "yuan"
    ],
    "flagClass": "currency-flag currency-flag-cn",
    "kind": "fiat"
  },
  {
    "code": "COMP",
    "name": "Compound",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "compound"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "COP",
    "name": "Colombian Peso",
    "symbol": "$",
    "countryCode": "co",
    "country": "Colombia",
    "aliases": [
      "colombian",
      "colombianpeso",
      "peso"
    ],
    "flagClass": "currency-flag currency-flag-co",
    "kind": "fiat"
  },
  {
    "code": "CRC",
    "name": "Costa Rican Colon",
    "symbol": null,
    "countryCode": "cr",
    "country": "Costa Rica",
    "aliases": [
      "colon",
      "costa",
      "costaricancolon",
      "rican"
    ],
    "flagClass": "currency-flag currency-flag-cr",
    "kind": "fiat"
  },
  {
    "code": "CRO",
    "name": "Crypto.com Chain",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "chain",
      "com",
      "crypto",
      "cryptocomchain"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "CRV",
    "name": "Curve DAO Token",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "curve",
      "curvedaotoken",
      "dao",
      "token"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "CSPR",
    "name": "Casper",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "casper"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "CUC",
    "name": "Cuban Convertible Peso",
    "symbol": null,
    "countryCode": "cu",
    "country": "Cuba",
    "aliases": [
      "convertible",
      "cuban",
      "cubanconvertiblepeso",
      "peso"
    ],
    "flagClass": "currency-flag currency-flag-cu",
    "kind": "fiat"
  },
  {
    "code": "CUP",
    "name": "Cuban Peso",
    "symbol": null,
    "countryCode": "cu",
    "country": "Cuba",
    "aliases": [
      "cuban",
      "cubanpeso",
      "peso"
    ],
    "flagClass": "currency-flag currency-flag-cu",
    "kind": "fiat"
  },
  {
    "code": "CVE",
    "name": "Cape Verdean Escudo",
    "symbol": null,
    "countryCode": "cv",
    "country": "Cape Verde",
    "aliases": [
      "cape",
      "capeverdeanescudo",
      "escudo",
      "verdean"
    ],
    "flagClass": "currency-flag currency-flag-cv",
    "kind": "fiat"
  },
  {
    "code": "CVX",
    "name": "Convex Finance",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "convex",
      "convexfinance",
      "finance"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "CYP",
    "name": "Cypriot Pound",
    "symbol": null,
    "countryCode": "cy",
    "country": "Cyprus",
    "aliases": [
      "cypriot",
      "cypriotpound",
      "pound"
    ],
    "flagClass": "currency-flag currency-flag-cy",
    "kind": "fiat"
  },
  {
    "code": "CZK",
    "name": "Czech Koruna",
    "symbol": "Kč",
    "countryCode": "cz",
    "country": "Czechia",
    "aliases": [
      "czech",
      "czechkoruna",
      "koruna"
    ],
    "flagClass": "currency-flag currency-flag-cz",
    "kind": "fiat"
  },
  {
    "code": "DAI",
    "name": "DAI",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "DASH",
    "name": "Digital Cash",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "cash",
      "digital",
      "digitalcash"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "DCR",
    "name": "Decred",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "decred"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "DEM",
    "name": "German Deutsche Mark",
    "symbol": null,
    "countryCode": "de",
    "country": "Germany",
    "aliases": [
      "deutsche",
      "german",
      "germandeutschemark",
      "mark"
    ],
    "flagClass": "currency-flag currency-flag-de",
    "kind": "fiat"
  },
  {
    "code": "DFI",
    "name": "DfiStarter",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "dfistarter"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "DJF",
    "name": "Djiboutian Franc",
    "symbol": null,
    "countryCode": "dj",
    "country": "Djibouti",
    "aliases": [
      "djiboutian",
      "djiboutianfranc",
      "franc"
    ],
    "flagClass": "currency-flag currency-flag-dj",
    "kind": "fiat"
  },
  {
    "code": "DKK",
    "name": "Danish Krone",
    "symbol": "kr",
    "countryCode": "dk",
    "country": "Denmark",
    "aliases": [
      "danish",
      "danishkrone",
      "krone"
    ],
    "flagClass": "currency-flag currency-flag-dk",
    "kind": "fiat"
  },
  {
    "code": "DOGE",
    "name": "Dogecoin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "dogecoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "DOP",
    "name": "Dominican Peso",
    "symbol": null,
    "countryCode": "do",
    "country": "Dominican Republic",
    "aliases": [
      "dominican",
      "dominicanpeso",
      "peso"
    ],
    "flagClass": "currency-flag currency-flag-do",
    "kind": "fiat"
  },
  {
    "code": "DOT",
    "name": "Polkadot",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "polkadot"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "DYDX",
    "name": "dYdX",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "DZD",
    "name": "Algerian Dinar",
    "symbol": "د.ج",
    "countryCode": "dz",
    "country": "Algeria",
    "aliases": [
      "algerian",
      "algeriandinar",
      "dinar"
    ],
    "flagClass": "currency-flag currency-flag-dz",
    "kind": "fiat"
  },
  {
    "code": "EEK",
    "name": "Estonian Kroon",
    "symbol": null,
    "countryCode": "ee",
    "country": "Estonia",
    "aliases": [
      "estonian",
      "estoniankroon",
      "kroon"
    ],
    "flagClass": "currency-flag currency-flag-ee",
    "kind": "fiat"
  },
  {
    "code": "EGLD",
    "name": "Elrond",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "elrond"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "EGP",
    "name": "Egyptian Pound",
    "symbol": "ج.م",
    "countryCode": "eg",
    "country": "Egypt",
    "aliases": [
      "egypt",
      "egyptian",
      "egyptianpound",
      "pound"
    ],
    "flagClass": "currency-flag currency-flag-eg",
    "kind": "fiat"
  },
  {
    "code": "ENJ",
    "name": "Enjin Coin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "coin",
      "enjin",
      "enjincoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "EOS",
    "name": "EOS",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ERN",
    "name": "Eritrean Nakfa",
    "symbol": null,
    "countryCode": "er",
    "country": "Eritrea",
    "aliases": [
      "eritrean",
      "eritreannakfa",
      "nakfa"
    ],
    "flagClass": "currency-flag currency-flag-er",
    "kind": "fiat"
  },
  {
    "code": "ESP",
    "name": "Spanish Peseta",
    "symbol": null,
    "countryCode": "es",
    "country": "Spain",
    "aliases": [
      "peseta",
      "spanish",
      "spanishpeseta"
    ],
    "flagClass": "currency-flag currency-flag-es",
    "kind": "fiat"
  },
  {
    "code": "ETB",
    "name": "Ethiopian Birr",
    "symbol": "Br",
    "countryCode": "et",
    "country": "Ethiopia",
    "aliases": [
      "birr",
      "ethiopian",
      "ethiopianbirr"
    ],
    "flagClass": "currency-flag currency-flag-et",
    "kind": "fiat"
  },
  {
    "code": "ETC",
    "name": "Ethereum Classic",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "classic",
      "ethereum",
      "ethereumclassic"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ETH",
    "name": "Ethereum",
    "symbol": "Ξ",
    "countryCode": null,
    "aliases": [
      "ethereum"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "EUR",
    "name": "Euro",
    "symbol": "€",
    "countryCode": "eu",
    "country": "Eurozone",
    "aliases": [
      "euro",
      "europe"
    ],
    "flagClass": "currency-flag currency-flag-eu",
    "kind": "fiat"
  },
  {
    "code": "EURC",
    "name": "Euro Coin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "coin",
      "euro",
      "eurocoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "FEI",
    "name": "Fei USD",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "usd"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "FIL",
    "name": "Filecoin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "filecoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "FIM",
    "name": "Finnish Markka",
    "symbol": null,
    "countryCode": "fi",
    "country": "Finland",
    "aliases": [
      "finnish",
      "finnishmarkka",
      "markka"
    ],
    "flagClass": "currency-flag currency-flag-fi",
    "kind": "fiat"
  },
  {
    "code": "FJD",
    "name": "Fijian Dollar",
    "symbol": null,
    "countryCode": "fj",
    "country": "Fiji",
    "aliases": [
      "dollar",
      "fijian",
      "fijiandollar"
    ],
    "flagClass": "currency-flag currency-flag-fj",
    "kind": "fiat"
  },
  {
    "code": "FKP",
    "name": "Falkland Island Pound",
    "symbol": null,
    "countryCode": "fk",
    "country": "Falkland Islands",
    "aliases": [
      "falkland",
      "falklandislandpound",
      "island",
      "pound"
    ],
    "flagClass": "currency-flag currency-flag-fk",
    "kind": "fiat"
  },
  {
    "code": "FLOW",
    "name": "Flow",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "FLR",
    "name": "FLARE",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "flare"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "FRAX",
    "name": "Frax",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "FRF",
    "name": "French Franc",
    "symbol": null,
    "countryCode": "fr",
    "country": "France",
    "aliases": [
      "franc",
      "french",
      "frenchfranc"
    ],
    "flagClass": "currency-flag currency-flag-fr",
    "kind": "fiat"
  },
  {
    "code": "FTT",
    "name": "FarmaTrust",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "farmatrust"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "GALA",
    "name": "Gala",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "GBP",
    "name": "British Pound",
    "symbol": "£",
    "countryCode": "gb",
    "country": "United Kingdom",
    "aliases": [
      "britain",
      "british",
      "britishpound",
      "pound"
    ],
    "flagClass": "currency-flag currency-flag-gb",
    "kind": "fiat"
  },
  {
    "code": "GEL",
    "name": "Georgian Lari",
    "symbol": "₾",
    "countryCode": "ge",
    "country": "Georgia",
    "aliases": [
      "georgian",
      "georgianlari",
      "lari"
    ],
    "flagClass": "currency-flag currency-flag-ge",
    "kind": "fiat"
  },
  {
    "code": "GGP",
    "name": "Guernsey Pound",
    "symbol": null,
    "countryCode": "gg",
    "country": "Guernsey",
    "aliases": [
      "guernsey",
      "guernseypound",
      "pound"
    ],
    "flagClass": "currency-flag currency-flag-gg",
    "kind": "fiat"
  },
  {
    "code": "GHC",
    "name": "Ghanaian Cedi",
    "symbol": null,
    "countryCode": "gh",
    "country": "Ghana",
    "aliases": [
      "cedi",
      "ghanaian",
      "ghanaiancedi"
    ],
    "flagClass": "currency-flag currency-flag-gh",
    "kind": "fiat"
  },
  {
    "code": "GHS",
    "name": "Ghanaian Cedi",
    "symbol": "₵",
    "countryCode": "gh",
    "country": "Ghana",
    "aliases": [
      "cedi",
      "ghanaian",
      "ghanaiancedi"
    ],
    "flagClass": "currency-flag currency-flag-gh",
    "kind": "fiat"
  },
  {
    "code": "GIP",
    "name": "Gibraltar Pound",
    "symbol": null,
    "countryCode": "gi",
    "country": "Gibraltar",
    "aliases": [
      "gibraltar",
      "gibraltarpound",
      "pound"
    ],
    "flagClass": "currency-flag currency-flag-gi",
    "kind": "fiat"
  },
  {
    "code": "GMD",
    "name": "Gambian Dalasi",
    "symbol": null,
    "countryCode": "gm",
    "country": "Gambia",
    "aliases": [
      "dalasi",
      "gambian",
      "gambiandalasi"
    ],
    "flagClass": "currency-flag currency-flag-gm",
    "kind": "fiat"
  },
  {
    "code": "GMX",
    "name": "Goldmaxcoin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "goldmaxcoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "GNF",
    "name": "Guinean Franc",
    "symbol": null,
    "countryCode": "gn",
    "country": "Guinea",
    "aliases": [
      "franc",
      "guinean",
      "guineanfranc"
    ],
    "flagClass": "currency-flag currency-flag-gn",
    "kind": "fiat"
  },
  {
    "code": "GNO",
    "name": "Gnosis",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "gnosis"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "GRD",
    "name": "Greek Drachma",
    "symbol": null,
    "countryCode": "gr",
    "country": "Greece",
    "aliases": [
      "drachma",
      "greek",
      "greekdrachma"
    ],
    "flagClass": "currency-flag currency-flag-gr",
    "kind": "fiat"
  },
  {
    "code": "GRT",
    "name": "The Graph",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "graph",
      "the",
      "thegraph"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "GT",
    "name": "GateToken",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "gatetoken"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "GTQ",
    "name": "Guatemalan Quetzal",
    "symbol": null,
    "countryCode": "gt",
    "country": "Guatemala",
    "aliases": [
      "guatemalan",
      "guatemalanquetzal",
      "quetzal"
    ],
    "flagClass": "currency-flag currency-flag-gt",
    "kind": "fiat"
  },
  {
    "code": "GUSD",
    "name": "Gemini US Dollar",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "dollar",
      "gemini",
      "geminiusdollar",
      "us"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "GYD",
    "name": "Guyanese Dollar",
    "symbol": null,
    "countryCode": "gy",
    "country": "Guyana",
    "aliases": [
      "dollar",
      "guyanese",
      "guyanesedollar"
    ],
    "flagClass": "currency-flag currency-flag-gy",
    "kind": "fiat"
  },
  {
    "code": "HBAR",
    "name": "Hedera",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "hedera"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "HKD",
    "name": "Hong Kong Dollar",
    "symbol": "HK$",
    "countryCode": "hk",
    "country": "Hong Kong",
    "aliases": [
      "dollar",
      "hong",
      "hongkongdollar",
      "kong"
    ],
    "flagClass": "currency-flag currency-flag-hk",
    "kind": "fiat"
  },
  {
    "code": "HNL",
    "name": "Honduran Lempira",
    "symbol": null,
    "countryCode": "hn",
    "country": "Honduras",
    "aliases": [
      "honduran",
      "honduranlempira",
      "lempira"
    ],
    "flagClass": "currency-flag currency-flag-hn",
    "kind": "fiat"
  },
  {
    "code": "HNT",
    "name": "Helium",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "helium"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "HOT",
    "name": "Hydro Protocol",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "hydro",
      "hydroprotocol",
      "protocol"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "HRK",
    "name": "Croatian Kuna",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "croatian",
      "croatiankuna",
      "kuna"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "HT",
    "name": "Huobi Token",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "huobi",
      "huobitoken",
      "token"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "HTG",
    "name": "Haitian Gourde",
    "symbol": null,
    "countryCode": "ht",
    "country": "Haiti",
    "aliases": [
      "gourde",
      "haitian",
      "haitiangourde"
    ],
    "flagClass": "currency-flag currency-flag-ht",
    "kind": "fiat"
  },
  {
    "code": "HUF",
    "name": "Hungarian Forint",
    "symbol": "Ft",
    "countryCode": "hu",
    "country": "Hungary",
    "aliases": [
      "forint",
      "hungarian",
      "hungarianforint"
    ],
    "flagClass": "currency-flag currency-flag-hu",
    "kind": "fiat"
  },
  {
    "code": "ICP",
    "name": "Internet Computer",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "computer",
      "internet",
      "internetcomputer"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "IDR",
    "name": "Indonesian Rupiah",
    "symbol": "Rp",
    "countryCode": "id",
    "country": "Indonesia",
    "aliases": [
      "indonesian",
      "indonesianrupiah",
      "rupiah"
    ],
    "flagClass": "currency-flag currency-flag-id",
    "kind": "fiat"
  },
  {
    "code": "IEP",
    "name": "Irish Pound",
    "symbol": null,
    "countryCode": "ie",
    "country": "Ireland",
    "aliases": [
      "irish",
      "irishpound",
      "pound"
    ],
    "flagClass": "currency-flag currency-flag-ie",
    "kind": "fiat"
  },
  {
    "code": "ILS",
    "name": "Israeli Shekel",
    "symbol": "₪",
    "countryCode": "il",
    "country": "Israel",
    "aliases": [
      "israeli",
      "israelishekel",
      "shekel"
    ],
    "flagClass": "currency-flag currency-flag-il",
    "kind": "fiat"
  },
  {
    "code": "IMP",
    "name": "Isle of Man Pound",
    "symbol": null,
    "countryCode": "im",
    "country": "Isle of Man",
    "aliases": [
      "isle",
      "isleofmanpound",
      "man",
      "of",
      "pound"
    ],
    "flagClass": "currency-flag currency-flag-im",
    "kind": "fiat"
  },
  {
    "code": "IMX",
    "name": "Immutable X",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "immutable"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "INJ",
    "name": "Injective",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "injective"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "INR",
    "name": "Indian Rupee",
    "symbol": "₹",
    "countryCode": "in",
    "country": "India",
    "aliases": [
      "india",
      "indian",
      "indianrupee",
      "rupee"
    ],
    "flagClass": "currency-flag currency-flag-in",
    "kind": "fiat"
  },
  {
    "code": "IQD",
    "name": "Iraqi Dinar",
    "symbol": "ع.د",
    "countryCode": "iq",
    "country": "Iraq",
    "aliases": [
      "dinar",
      "iraqi",
      "iraqidinar"
    ],
    "flagClass": "currency-flag currency-flag-iq",
    "kind": "fiat"
  },
  {
    "code": "IRR",
    "name": "Iranian Rial",
    "symbol": null,
    "countryCode": "ir",
    "country": "Iran",
    "aliases": [
      "iranian",
      "iranianrial",
      "rial"
    ],
    "flagClass": "currency-flag currency-flag-ir",
    "kind": "fiat"
  },
  {
    "code": "ISK",
    "name": "Icelandic Krona",
    "symbol": null,
    "countryCode": "is",
    "country": "Iceland",
    "aliases": [
      "icelandic",
      "icelandickrona",
      "krona"
    ],
    "flagClass": "currency-flag currency-flag-is",
    "kind": "fiat"
  },
  {
    "code": "ITL",
    "name": "Italian Lira",
    "symbol": null,
    "countryCode": "it",
    "country": "Italy",
    "aliases": [
      "italian",
      "italianlira",
      "lira"
    ],
    "flagClass": "currency-flag currency-flag-it",
    "kind": "fiat"
  },
  {
    "code": "JEP",
    "name": "Jersey Pound",
    "symbol": null,
    "countryCode": "je",
    "country": "Jersey",
    "aliases": [
      "jersey",
      "jerseypound",
      "pound"
    ],
    "flagClass": "currency-flag currency-flag-je",
    "kind": "fiat"
  },
  {
    "code": "JMD",
    "name": "Jamaican Dollar",
    "symbol": null,
    "countryCode": "jm",
    "country": "Jamaica",
    "aliases": [
      "dollar",
      "jamaican",
      "jamaicandollar"
    ],
    "flagClass": "currency-flag currency-flag-jm",
    "kind": "fiat"
  },
  {
    "code": "JOD",
    "name": "Jordanian Dinar",
    "symbol": "د.ا",
    "countryCode": "jo",
    "country": "Jordan",
    "aliases": [
      "dinar",
      "jordanian",
      "jordaniandinar"
    ],
    "flagClass": "currency-flag currency-flag-jo",
    "kind": "fiat"
  },
  {
    "code": "JPY",
    "name": "Japanese Yen",
    "symbol": "¥",
    "countryCode": "jp",
    "country": "Japan",
    "aliases": [
      "japan",
      "japanese",
      "japaneseyen",
      "yen"
    ],
    "flagClass": "currency-flag currency-flag-jp",
    "kind": "fiat"
  },
  {
    "code": "KAS",
    "name": "Kaspa",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "kaspa"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "KAVA",
    "name": "Kava",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "KCS",
    "name": "Kucoin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "kucoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "KDA",
    "name": "Kadena",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "kadena"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "KES",
    "name": "Kenyan Shilling",
    "symbol": "KSh",
    "countryCode": "ke",
    "country": "Kenya",
    "aliases": [
      "kenyan",
      "kenyanshilling",
      "shilling"
    ],
    "flagClass": "currency-flag currency-flag-ke",
    "kind": "fiat"
  },
  {
    "code": "KGS",
    "name": "Kyrgyzstani Som",
    "symbol": null,
    "countryCode": "kg",
    "country": "Kyrgyzstan",
    "aliases": [
      "kyrgyzstani",
      "kyrgyzstanisom",
      "som"
    ],
    "flagClass": "currency-flag currency-flag-kg",
    "kind": "fiat"
  },
  {
    "code": "KHR",
    "name": "Cambodian Riel",
    "symbol": null,
    "countryCode": "kh",
    "country": "Cambodia",
    "aliases": [
      "cambodian",
      "cambodianriel",
      "riel"
    ],
    "flagClass": "currency-flag currency-flag-kh",
    "kind": "fiat"
  },
  {
    "code": "KLAY",
    "name": "Klaytn",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "klaytn"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "KMF",
    "name": "Comorian Franc",
    "symbol": null,
    "countryCode": "km",
    "country": "Comoros",
    "aliases": [
      "comorian",
      "comorianfranc",
      "franc"
    ],
    "flagClass": "currency-flag currency-flag-km",
    "kind": "fiat"
  },
  {
    "code": "KNC",
    "name": "Kyber Network Crystals",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "crystals",
      "kyber",
      "kybernetworkcrystals",
      "network"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "KPW",
    "name": "North Korean Won",
    "symbol": null,
    "countryCode": "kp",
    "country": "North Korea",
    "aliases": [
      "korean",
      "north",
      "northkoreanwon",
      "won"
    ],
    "flagClass": "currency-flag currency-flag-kp",
    "kind": "fiat"
  },
  {
    "code": "KRW",
    "name": "South Korean Won",
    "symbol": "₩",
    "countryCode": "kr",
    "country": "South Korea",
    "aliases": [
      "korea",
      "korean",
      "south",
      "southkoreanwon",
      "won"
    ],
    "flagClass": "currency-flag currency-flag-kr",
    "kind": "fiat"
  },
  {
    "code": "KSM",
    "name": "Kusama",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "kusama"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "KWD",
    "name": "Kuwaiti Dinar",
    "symbol": "د.ك",
    "countryCode": "kw",
    "country": "Kuwait",
    "aliases": [
      "dinar",
      "kuwait",
      "kuwaiti",
      "kuwaitidinar"
    ],
    "flagClass": "currency-flag currency-flag-kw",
    "kind": "fiat"
  },
  {
    "code": "KYD",
    "name": "Caymanian Dollar",
    "symbol": null,
    "countryCode": "ky",
    "country": "Cayman Islands",
    "aliases": [
      "caymanian",
      "caymaniandollar",
      "dollar"
    ],
    "flagClass": "currency-flag currency-flag-ky",
    "kind": "fiat"
  },
  {
    "code": "KZT",
    "name": "Kazakhstani Tenge",
    "symbol": "₸",
    "countryCode": "kz",
    "country": "Kazakhstan",
    "aliases": [
      "kazakhstani",
      "kazakhstanitenge",
      "tenge"
    ],
    "flagClass": "currency-flag currency-flag-kz",
    "kind": "fiat"
  },
  {
    "code": "LAK",
    "name": "Lao Kip",
    "symbol": null,
    "countryCode": "la",
    "country": "Laos",
    "aliases": [
      "kip",
      "lao",
      "laokip"
    ],
    "flagClass": "currency-flag currency-flag-la",
    "kind": "fiat"
  },
  {
    "code": "LBP",
    "name": "Lebanese Pound",
    "symbol": "ل.ل",
    "countryCode": "lb",
    "country": "Lebanon",
    "aliases": [
      "lebanese",
      "lebanesepound",
      "pound"
    ],
    "flagClass": "currency-flag currency-flag-lb",
    "kind": "fiat"
  },
  {
    "code": "LDO",
    "name": "Lido DAO Token",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "dao",
      "lido",
      "lidodaotoken",
      "token"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "LEO",
    "name": "LEOcoin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "leocoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "LINK",
    "name": "Chainlink",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "chainlink"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "LKR",
    "name": "Sri Lankan Rupee",
    "symbol": null,
    "countryCode": "lk",
    "country": "Sri Lanka",
    "aliases": [
      "lankan",
      "rupee",
      "sri",
      "srilankanrupee"
    ],
    "flagClass": "currency-flag currency-flag-lk",
    "kind": "fiat"
  },
  {
    "code": "LRC",
    "name": "Loopring",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "loopring"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "LRD",
    "name": "Liberian Dollar",
    "symbol": null,
    "countryCode": "lr",
    "country": "Liberia",
    "aliases": [
      "dollar",
      "liberian",
      "liberiandollar"
    ],
    "flagClass": "currency-flag currency-flag-lr",
    "kind": "fiat"
  },
  {
    "code": "LSL",
    "name": "Basotho Loti",
    "symbol": null,
    "countryCode": "ls",
    "country": "Lesotho",
    "aliases": [
      "basotho",
      "basotholoti",
      "loti"
    ],
    "flagClass": "currency-flag currency-flag-ls",
    "kind": "fiat"
  },
  {
    "code": "LTC",
    "name": "Litecoin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "litecoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "LTL",
    "name": "Lithuanian Litas",
    "symbol": null,
    "countryCode": "lt",
    "country": "Lithuania",
    "aliases": [
      "litas",
      "lithuanian",
      "lithuanianlitas"
    ],
    "flagClass": "currency-flag currency-flag-lt",
    "kind": "fiat"
  },
  {
    "code": "LUF",
    "name": "Luxembourg Franc",
    "symbol": null,
    "countryCode": "lu",
    "country": "Luxembourg",
    "aliases": [
      "franc",
      "luxembourg",
      "luxembourgfranc"
    ],
    "flagClass": "currency-flag currency-flag-lu",
    "kind": "fiat"
  },
  {
    "code": "LUNA",
    "name": "Terra",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "terra"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "LUNC",
    "name": "Terra Luna Classic",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "classic",
      "luna",
      "terra",
      "terralunaclassic"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "LVL",
    "name": "Latvian Lat",
    "symbol": null,
    "countryCode": "lv",
    "country": "Latvia",
    "aliases": [
      "lat",
      "latvian",
      "latvianlat"
    ],
    "flagClass": "currency-flag currency-flag-lv",
    "kind": "fiat"
  },
  {
    "code": "LYD",
    "name": "Libyan Dinar",
    "symbol": "ل.د",
    "countryCode": "ly",
    "country": "Libya",
    "aliases": [
      "dinar",
      "libyan",
      "libyandinar"
    ],
    "flagClass": "currency-flag currency-flag-ly",
    "kind": "fiat"
  },
  {
    "code": "MAD",
    "name": "Moroccan Dirham",
    "symbol": "د.م.",
    "countryCode": "ma",
    "country": "Morocco",
    "aliases": [
      "dirham",
      "maroc",
      "moroccan",
      "moroccandirham",
      "morocco"
    ],
    "flagClass": "currency-flag currency-flag-ma",
    "kind": "fiat"
  },
  {
    "code": "MANA",
    "name": "Mana Coin Decentraland",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "coin",
      "coindecentraland",
      "decentraland"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "MBX",
    "name": "MobieCoin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "mobiecoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "MDL",
    "name": "Moldovan Leu",
    "symbol": null,
    "countryCode": "md",
    "country": "Moldova",
    "aliases": [
      "leu",
      "moldovan",
      "moldovanleu"
    ],
    "flagClass": "currency-flag currency-flag-md",
    "kind": "fiat"
  },
  {
    "code": "MGA",
    "name": "Malagasy Ariary",
    "symbol": null,
    "countryCode": "mg",
    "country": "Madagascar",
    "aliases": [
      "ariary",
      "malagasy",
      "malagasyariary"
    ],
    "flagClass": "currency-flag currency-flag-mg",
    "kind": "fiat"
  },
  {
    "code": "MGF",
    "name": "Malagasy Franc",
    "symbol": null,
    "countryCode": "mg",
    "country": "Madagascar",
    "aliases": [
      "franc",
      "malagasy",
      "malagasyfranc"
    ],
    "flagClass": "currency-flag currency-flag-mg",
    "kind": "fiat"
  },
  {
    "code": "MINA",
    "name": "Mina",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "MKD",
    "name": "Macedonian Denar",
    "symbol": null,
    "countryCode": "mk",
    "country": "North Macedonia",
    "aliases": [
      "denar",
      "macedonian",
      "macedoniandenar"
    ],
    "flagClass": "currency-flag currency-flag-mk",
    "kind": "fiat"
  },
  {
    "code": "MKR",
    "name": "Maker",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "maker"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "MMK",
    "name": "Burmese Kyat",
    "symbol": null,
    "countryCode": "mm",
    "country": "Myanmar",
    "aliases": [
      "burmese",
      "burmesekyat",
      "kyat"
    ],
    "flagClass": "currency-flag currency-flag-mm",
    "kind": "fiat"
  },
  {
    "code": "MNT",
    "name": "Mongolian Tughrik",
    "symbol": null,
    "countryCode": "mn",
    "country": "Mongolia",
    "aliases": [
      "mongolian",
      "mongoliantughrik",
      "tughrik"
    ],
    "flagClass": "currency-flag currency-flag-mn",
    "kind": "fiat"
  },
  {
    "code": "MOP",
    "name": "Macau Pataca",
    "symbol": null,
    "countryCode": "mo",
    "country": "Macau",
    "aliases": [
      "macau",
      "macaupataca",
      "pataca"
    ],
    "flagClass": "currency-flag currency-flag-mo",
    "kind": "fiat"
  },
  {
    "code": "MRO",
    "name": "Mauritanian Ouguiya",
    "symbol": null,
    "countryCode": "mr",
    "country": "Mauritania",
    "aliases": [
      "mauritanian",
      "mauritanianouguiya",
      "ouguiya"
    ],
    "flagClass": "currency-flag currency-flag-mr",
    "kind": "fiat"
  },
  {
    "code": "MRU",
    "name": "Mauritanian Ouguiya",
    "symbol": "أ.م",
    "countryCode": "mr",
    "country": "Mauritania",
    "aliases": [
      "mauritanian",
      "mauritanianouguiya",
      "ouguiya"
    ],
    "flagClass": "currency-flag currency-flag-mr",
    "kind": "fiat"
  },
  {
    "code": "MTL",
    "name": "Maltese Lira",
    "symbol": null,
    "countryCode": "mt",
    "country": "Malta",
    "aliases": [
      "lira",
      "maltese",
      "malteselira"
    ],
    "flagClass": "currency-flag currency-flag-mt",
    "kind": "fiat"
  },
  {
    "code": "MUR",
    "name": "Mauritian Rupee",
    "symbol": null,
    "countryCode": "mu",
    "country": "Mauritius",
    "aliases": [
      "mauritian",
      "mauritianrupee",
      "rupee"
    ],
    "flagClass": "currency-flag currency-flag-mu",
    "kind": "fiat"
  },
  {
    "code": "MVR",
    "name": "Maldivian Rufiyaa",
    "symbol": null,
    "countryCode": "mv",
    "country": "Maldives",
    "aliases": [
      "maldivian",
      "maldivianrufiyaa",
      "rufiyaa"
    ],
    "flagClass": "currency-flag currency-flag-mv",
    "kind": "fiat"
  },
  {
    "code": "MWK",
    "name": "Malawian Kwacha",
    "symbol": null,
    "countryCode": "mw",
    "country": "Malawi",
    "aliases": [
      "kwacha",
      "malawian",
      "malawiankwacha"
    ],
    "flagClass": "currency-flag currency-flag-mw",
    "kind": "fiat"
  },
  {
    "code": "MXN",
    "name": "Mexican Peso",
    "symbol": "$",
    "countryCode": "mx",
    "country": "Mexico",
    "aliases": [
      "mexican",
      "mexicanpeso",
      "peso"
    ],
    "flagClass": "currency-flag currency-flag-mx",
    "kind": "fiat"
  },
  {
    "code": "MXV",
    "name": "Mexican Unidad de Inversion",
    "symbol": null,
    "countryCode": null,
    "country": "Mexico",
    "aliases": [
      "de",
      "inversion",
      "mexican",
      "mexicanunidaddeinversion",
      "unidad"
    ],
    "flagClass": null,
    "kind": "other"
  },
  {
    "code": "MYR",
    "name": "Malaysian Ringgit",
    "symbol": "RM",
    "countryCode": "my",
    "country": "Malaysia",
    "aliases": [
      "malaysian",
      "malaysianringgit",
      "ringgit"
    ],
    "flagClass": "currency-flag currency-flag-my",
    "kind": "fiat"
  },
  {
    "code": "MZM",
    "name": "Mozambican Metical",
    "symbol": null,
    "countryCode": "mz",
    "country": "Mozambique",
    "aliases": [
      "metical",
      "mozambican",
      "mozambicanmetical"
    ],
    "flagClass": "currency-flag currency-flag-mz",
    "kind": "fiat"
  },
  {
    "code": "MZN",
    "name": "Mozambican Metical",
    "symbol": null,
    "countryCode": "mz",
    "country": "Mozambique",
    "aliases": [
      "metical",
      "mozambican",
      "mozambicanmetical"
    ],
    "flagClass": "currency-flag currency-flag-mz",
    "kind": "fiat"
  },
  {
    "code": "NAD",
    "name": "Namibian Dollar",
    "symbol": null,
    "countryCode": "na",
    "country": "Namibia",
    "aliases": [
      "dollar",
      "namibian",
      "namibiandollar"
    ],
    "flagClass": "currency-flag currency-flag-na",
    "kind": "fiat"
  },
  {
    "code": "NEAR",
    "name": "NEAR Protocol",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "protocol"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "NEO",
    "name": "NEO",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "NEXO",
    "name": "NEXO",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "NFT",
    "name": "NFT",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "NGN",
    "name": "Nigerian Naira",
    "symbol": "₦",
    "countryCode": "ng",
    "country": "Nigeria",
    "aliases": [
      "naira",
      "nigerian",
      "nigeriannaira"
    ],
    "flagClass": "currency-flag currency-flag-ng",
    "kind": "fiat"
  },
  {
    "code": "NIO",
    "name": "Nicaraguan Cordoba",
    "symbol": null,
    "countryCode": "ni",
    "country": "Nicaragua",
    "aliases": [
      "cordoba",
      "nicaraguan",
      "nicaraguancordoba"
    ],
    "flagClass": "currency-flag currency-flag-ni",
    "kind": "fiat"
  },
  {
    "code": "NLG",
    "name": "Dutch Guilder",
    "symbol": null,
    "countryCode": "nl",
    "country": "Netherlands",
    "aliases": [
      "dutch",
      "dutchguilder",
      "guilder"
    ],
    "flagClass": "currency-flag currency-flag-nl",
    "kind": "fiat"
  },
  {
    "code": "NOK",
    "name": "Norwegian Krone",
    "symbol": "kr",
    "countryCode": "no",
    "country": "Norway",
    "aliases": [
      "krone",
      "norwegian",
      "norwegiankrone"
    ],
    "flagClass": "currency-flag currency-flag-no",
    "kind": "fiat"
  },
  {
    "code": "NPR",
    "name": "Nepalese Rupee",
    "symbol": null,
    "countryCode": "np",
    "country": "Nepal",
    "aliases": [
      "nepalese",
      "nepaleserupee",
      "rupee"
    ],
    "flagClass": "currency-flag currency-flag-np",
    "kind": "fiat"
  },
  {
    "code": "NZD",
    "name": "New Zealand Dollar",
    "symbol": "NZ$",
    "countryCode": "nz",
    "country": "New Zealand",
    "aliases": [
      "dollar",
      "new",
      "newzealanddollar",
      "zealand"
    ],
    "flagClass": "currency-flag currency-flag-nz",
    "kind": "fiat"
  },
  {
    "code": "OKB",
    "name": "Okex",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "okex"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "OMR",
    "name": "Omani Rial",
    "symbol": "ر.ع.",
    "countryCode": "om",
    "country": "Oman",
    "aliases": [
      "omani",
      "omanirial",
      "rial"
    ],
    "flagClass": "currency-flag currency-flag-om",
    "kind": "fiat"
  },
  {
    "code": "ONE",
    "name": "Menlo One",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "menlo"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "OP",
    "name": "Optimism",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "optimism"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ORDI",
    "name": "Ordinals",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "ordinals"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "PAB",
    "name": "Panamanian Balboa",
    "symbol": null,
    "countryCode": "pa",
    "country": "Panama",
    "aliases": [
      "balboa",
      "panamanian",
      "panamanianbalboa"
    ],
    "flagClass": "currency-flag currency-flag-pa",
    "kind": "fiat"
  },
  {
    "code": "PAXG",
    "name": "PAX Gold",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "gold",
      "pax",
      "paxgold"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "PEN",
    "name": "Peruvian Sol",
    "symbol": "S/",
    "countryCode": "pe",
    "country": "Peru",
    "aliases": [
      "peruvian",
      "peruviansol",
      "sol"
    ],
    "flagClass": "currency-flag currency-flag-pe",
    "kind": "fiat"
  },
  {
    "code": "PEPE",
    "name": "Pepe",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "PGK",
    "name": "Papua New Guinean Kina",
    "symbol": null,
    "countryCode": "pg",
    "country": "Papua New Guinea",
    "aliases": [
      "guinean",
      "kina",
      "new",
      "papua",
      "papuanewguineankina"
    ],
    "flagClass": "currency-flag currency-flag-pg",
    "kind": "fiat"
  },
  {
    "code": "PHP",
    "name": "Philippine Peso",
    "symbol": "₱",
    "countryCode": "ph",
    "country": "Philippines",
    "aliases": [
      "peso",
      "philippine",
      "philippinepeso"
    ],
    "flagClass": "currency-flag currency-flag-ph",
    "kind": "fiat"
  },
  {
    "code": "PI",
    "name": "Plian",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "plian"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "PKR",
    "name": "Pakistani Rupee",
    "symbol": "₨",
    "countryCode": "pk",
    "country": "Pakistan",
    "aliases": [
      "pakistani",
      "pakistanirupee",
      "rupee"
    ],
    "flagClass": "currency-flag currency-flag-pk",
    "kind": "fiat"
  },
  {
    "code": "PLN",
    "name": "Polish Zloty",
    "symbol": "zł",
    "countryCode": "pl",
    "country": "Poland",
    "aliases": [
      "polish",
      "polishzloty",
      "zloty"
    ],
    "flagClass": "currency-flag currency-flag-pl",
    "kind": "fiat"
  },
  {
    "code": "POL",
    "name": "Proof Of Liquidity",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "liquidity",
      "of",
      "proof",
      "proofofliquidity"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "PTE",
    "name": "Portuguese Escudo",
    "symbol": null,
    "countryCode": "pt",
    "country": "Portugal",
    "aliases": [
      "escudo",
      "portuguese",
      "portugueseescudo"
    ],
    "flagClass": "currency-flag currency-flag-pt",
    "kind": "fiat"
  },
  {
    "code": "PYG",
    "name": "Paraguayan Guarani",
    "symbol": null,
    "countryCode": "py",
    "country": "Paraguay",
    "aliases": [
      "guarani",
      "paraguayan",
      "paraguayanguarani"
    ],
    "flagClass": "currency-flag currency-flag-py",
    "kind": "fiat"
  },
  {
    "code": "QAR",
    "name": "Qatari Riyal",
    "symbol": "ر.ق",
    "countryCode": "qa",
    "country": "Qatar",
    "aliases": [
      "qatar",
      "qatari",
      "qataririyal",
      "riyal"
    ],
    "flagClass": "currency-flag currency-flag-qa",
    "kind": "fiat"
  },
  {
    "code": "QNT",
    "name": "Quant",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "quant"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "QTUM",
    "name": "QTUM",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ROL",
    "name": "Romanian Leu",
    "symbol": null,
    "countryCode": "ro",
    "country": "Romania",
    "aliases": [
      "leu",
      "romanian",
      "romanianleu"
    ],
    "flagClass": "currency-flag currency-flag-ro",
    "kind": "fiat"
  },
  {
    "code": "RON",
    "name": "Romanian Leu",
    "symbol": "lei",
    "countryCode": "ro",
    "country": "Romania",
    "aliases": [
      "leu",
      "romanian",
      "romanianleu"
    ],
    "flagClass": "currency-flag currency-flag-ro",
    "kind": "fiat"
  },
  {
    "code": "RPL",
    "name": "Rocket Pool",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "pool",
      "rocket",
      "rocketpool"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "RSD",
    "name": "Serbian Dinar",
    "symbol": null,
    "countryCode": "rs",
    "country": "Serbia",
    "aliases": [
      "dinar",
      "serbian",
      "serbiandinar"
    ],
    "flagClass": "currency-flag currency-flag-rs",
    "kind": "fiat"
  },
  {
    "code": "RUB",
    "name": "Russian Ruble",
    "symbol": "₽",
    "countryCode": "ru",
    "country": "Russia",
    "aliases": [
      "ruble",
      "russian",
      "russianruble"
    ],
    "flagClass": "currency-flag currency-flag-ru",
    "kind": "fiat"
  },
  {
    "code": "RUNE",
    "name": "THORChain (ERC20)",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "erc20",
      "thorchain",
      "thorchainerc20"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "RVN",
    "name": "Ravencoin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "ravencoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "RWF",
    "name": "Rwandan Franc",
    "symbol": null,
    "countryCode": "rw",
    "country": "Rwanda",
    "aliases": [
      "franc",
      "rwandan",
      "rwandanfranc"
    ],
    "flagClass": "currency-flag currency-flag-rw",
    "kind": "fiat"
  },
  {
    "code": "SAND",
    "name": "The Sandbox",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "sandbox",
      "the",
      "thesandbox"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "SAR",
    "name": "Saudi Arabian Riyal",
    "symbol": "﷼",
    "countryCode": "sa",
    "country": "Saudi Arabia",
    "aliases": [
      "arabian",
      "ksa",
      "riyal",
      "saudi",
      "saudiarabianriyal"
    ],
    "flagClass": "currency-flag currency-flag-sa",
    "kind": "fiat"
  },
  {
    "code": "SBD",
    "name": "Solomon Islander Dollar",
    "symbol": null,
    "countryCode": "sb",
    "country": "Solomon Islands",
    "aliases": [
      "dollar",
      "islander",
      "solomon",
      "solomonislanderdollar"
    ],
    "flagClass": "currency-flag currency-flag-sb",
    "kind": "fiat"
  },
  {
    "code": "SCR",
    "name": "Seychellois Rupee",
    "symbol": null,
    "countryCode": "sc",
    "country": "Seychelles",
    "aliases": [
      "rupee",
      "seychellois",
      "seychelloisrupee"
    ],
    "flagClass": "currency-flag currency-flag-sc",
    "kind": "fiat"
  },
  {
    "code": "SDD",
    "name": "Sudanese Dinar",
    "symbol": null,
    "countryCode": "sd",
    "country": "Sudan",
    "aliases": [
      "dinar",
      "sudanese",
      "sudanesedinar"
    ],
    "flagClass": "currency-flag currency-flag-sd",
    "kind": "fiat"
  },
  {
    "code": "SDG",
    "name": "Sudanese Pound",
    "symbol": "ج.س",
    "countryCode": "sd",
    "country": "Sudan",
    "aliases": [
      "pound",
      "sudanese",
      "sudanesepound"
    ],
    "flagClass": "currency-flag currency-flag-sd",
    "kind": "fiat"
  },
  {
    "code": "SEK",
    "name": "Swedish Krona",
    "symbol": "kr",
    "countryCode": "se",
    "country": "Sweden",
    "aliases": [
      "krona",
      "swedish",
      "swedishkrona"
    ],
    "flagClass": "currency-flag currency-flag-se",
    "kind": "fiat"
  },
  {
    "code": "SGD",
    "name": "Singapore Dollar",
    "symbol": "S$",
    "countryCode": "sg",
    "country": "Singapore",
    "aliases": [
      "dollar",
      "singapore",
      "singaporedollar"
    ],
    "flagClass": "currency-flag currency-flag-sg",
    "kind": "fiat"
  },
  {
    "code": "SHIB",
    "name": "Shiba Inu",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "inu",
      "shiba",
      "shibainu"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "SHP",
    "name": "Saint Helenian Pound",
    "symbol": null,
    "countryCode": "sh",
    "country": "Saint Helena",
    "aliases": [
      "helenian",
      "pound",
      "saint",
      "sainthelenianpound"
    ],
    "flagClass": "currency-flag currency-flag-sh",
    "kind": "fiat"
  },
  {
    "code": "SIT",
    "name": "Slovenian Tolar",
    "symbol": null,
    "countryCode": "si",
    "country": "Slovenia",
    "aliases": [
      "slovenian",
      "sloveniantolar",
      "tolar"
    ],
    "flagClass": "currency-flag currency-flag-si",
    "kind": "fiat"
  },
  {
    "code": "SKK",
    "name": "Slovak Koruna",
    "symbol": null,
    "countryCode": "sk",
    "country": "Slovakia",
    "aliases": [
      "koruna",
      "slovak",
      "slovakkoruna"
    ],
    "flagClass": "currency-flag currency-flag-sk",
    "kind": "fiat"
  },
  {
    "code": "SLE",
    "name": "Sierra Leonean Leone",
    "symbol": null,
    "countryCode": "sl",
    "country": "Sierra Leone",
    "aliases": [
      "leone",
      "leonean",
      "sierra",
      "sierraleoneanleone"
    ],
    "flagClass": "currency-flag currency-flag-sl",
    "kind": "fiat"
  },
  {
    "code": "SLL",
    "name": "Sierra Leonean Leone",
    "symbol": null,
    "countryCode": "sl",
    "country": "Sierra Leone",
    "aliases": [
      "leone",
      "leonean",
      "sierra",
      "sierraleoneanleone"
    ],
    "flagClass": "currency-flag currency-flag-sl",
    "kind": "fiat"
  },
  {
    "code": "SNX",
    "name": "Synthetix Network",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "network",
      "synthetix",
      "synthetixnetwork"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "SOL",
    "name": "Solana",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "solana"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "SOS",
    "name": "Somali Shilling",
    "symbol": null,
    "countryCode": "so",
    "country": "Somalia",
    "aliases": [
      "shilling",
      "somali",
      "somalishilling"
    ],
    "flagClass": "currency-flag currency-flag-so",
    "kind": "fiat"
  },
  {
    "code": "SPL",
    "name": "Seborgan Luigino",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "luigino",
      "seborgan",
      "seborganluigino"
    ],
    "flagClass": null,
    "kind": "other"
  },
  {
    "code": "SRD",
    "name": "Surinamese Dollar",
    "symbol": null,
    "countryCode": "sr",
    "country": "Suriname",
    "aliases": [
      "dollar",
      "surinamese",
      "surinamesedollar"
    ],
    "flagClass": "currency-flag currency-flag-sr",
    "kind": "fiat"
  },
  {
    "code": "SRG",
    "name": "Surinamese Guilder",
    "symbol": null,
    "countryCode": "sr",
    "country": "Suriname",
    "aliases": [
      "guilder",
      "surinamese",
      "surinameseguilder"
    ],
    "flagClass": "currency-flag currency-flag-sr",
    "kind": "fiat"
  },
  {
    "code": "SSP",
    "name": "South Sudanese Pound",
    "symbol": null,
    "countryCode": "ss",
    "country": "South Sudan",
    "aliases": [
      "pound",
      "south",
      "southsudanesepound",
      "sudanese"
    ],
    "flagClass": "currency-flag currency-flag-ss",
    "kind": "fiat"
  },
  {
    "code": "STD",
    "name": "Sao Tomean Dobra",
    "symbol": null,
    "countryCode": "st",
    "country": "Sao Tome and Principe",
    "aliases": [
      "dobra",
      "sao",
      "saotomeandobra",
      "tomean"
    ],
    "flagClass": "currency-flag currency-flag-st",
    "kind": "fiat"
  },
  {
    "code": "STN",
    "name": "Sao Tomean Dobra",
    "symbol": null,
    "countryCode": "st",
    "country": "Sao Tome and Principe",
    "aliases": [
      "dobra",
      "sao",
      "saotomeandobra",
      "tomean"
    ],
    "flagClass": "currency-flag currency-flag-st",
    "kind": "fiat"
  },
  {
    "code": "STX",
    "name": "Stacks",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "stacks"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "SUI",
    "name": "Sui",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "SVC",
    "name": "Salvadoran Colon",
    "symbol": null,
    "countryCode": "sv",
    "country": "El Salvador",
    "aliases": [
      "colon",
      "salvadoran",
      "salvadorancolon"
    ],
    "flagClass": "currency-flag currency-flag-sv",
    "kind": "fiat"
  },
  {
    "code": "SYP",
    "name": "Syrian Pound",
    "symbol": "ل.س",
    "countryCode": "sy",
    "country": "Syria",
    "aliases": [
      "pound",
      "syrian",
      "syrianpound"
    ],
    "flagClass": "currency-flag currency-flag-sy",
    "kind": "fiat"
  },
  {
    "code": "SZL",
    "name": "Swazi Lilangeni",
    "symbol": null,
    "countryCode": "sz",
    "country": "Eswatini",
    "aliases": [
      "lilangeni",
      "swazi",
      "swazililangeni"
    ],
    "flagClass": "currency-flag currency-flag-sz",
    "kind": "fiat"
  },
  {
    "code": "THB",
    "name": "Thai Baht",
    "symbol": "฿",
    "countryCode": "th",
    "country": "Thailand",
    "aliases": [
      "baht",
      "thai",
      "thaibaht"
    ],
    "flagClass": "currency-flag currency-flag-th",
    "kind": "fiat"
  },
  {
    "code": "THETA",
    "name": "Theta",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "TJS",
    "name": "Tajikistani Somoni",
    "symbol": null,
    "countryCode": "tj",
    "country": "Tajikistan",
    "aliases": [
      "somoni",
      "tajikistani",
      "tajikistanisomoni"
    ],
    "flagClass": "currency-flag currency-flag-tj",
    "kind": "fiat"
  },
  {
    "code": "TMM",
    "name": "Turkmenistani Manat",
    "symbol": null,
    "countryCode": "tm",
    "country": "Turkmenistan",
    "aliases": [
      "manat",
      "turkmenistani",
      "turkmenistanimanat"
    ],
    "flagClass": "currency-flag currency-flag-tm",
    "kind": "fiat"
  },
  {
    "code": "TMT",
    "name": "Turkmenistani Manat",
    "symbol": null,
    "countryCode": "tm",
    "country": "Turkmenistan",
    "aliases": [
      "manat",
      "turkmenistani",
      "turkmenistanimanat"
    ],
    "flagClass": "currency-flag currency-flag-tm",
    "kind": "fiat"
  },
  {
    "code": "TND",
    "name": "Tunisian Dinar",
    "symbol": "د.ت",
    "countryCode": "tn",
    "country": "Tunisia",
    "aliases": [
      "dinar",
      "tunisian",
      "tunisiandinar"
    ],
    "flagClass": "currency-flag currency-flag-tn",
    "kind": "fiat"
  },
  {
    "code": "TOP",
    "name": "Tongan Pa'anga",
    "symbol": null,
    "countryCode": "to",
    "country": "Tonga",
    "aliases": [
      "anga",
      "pa",
      "tongan",
      "tonganpaanga"
    ],
    "flagClass": "currency-flag currency-flag-to",
    "kind": "fiat"
  },
  {
    "code": "TRL",
    "name": "Turkish Lira (Old)",
    "symbol": null,
    "countryCode": null,
    "country": "Türkiye",
    "aliases": [
      "lira",
      "old",
      "turkish",
      "turkishliraold"
    ],
    "flagClass": null,
    "kind": "other"
  },
  {
    "code": "TRX",
    "name": "TRON",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "tron"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "TRY",
    "name": "Turkish Lira",
    "symbol": "₺",
    "countryCode": "tr",
    "country": "Türkiye",
    "aliases": [
      "lira",
      "turkey",
      "turkish",
      "turkishlira",
      "turkiye"
    ],
    "flagClass": "currency-flag currency-flag-tr",
    "kind": "fiat"
  },
  {
    "code": "TTD",
    "name": "Trinidadian Dollar",
    "symbol": null,
    "countryCode": "tt",
    "country": "Trinidad and Tobago",
    "aliases": [
      "dollar",
      "trinidadian",
      "trinidadiandollar"
    ],
    "flagClass": "currency-flag currency-flag-tt",
    "kind": "fiat"
  },
  {
    "code": "TUSD",
    "name": "True USD",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "true",
      "trueusd",
      "usd"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "TVD",
    "name": "Tuvaluan Dollar",
    "symbol": null,
    "countryCode": "tv",
    "country": "Tuvalu",
    "aliases": [
      "dollar",
      "tuvaluan",
      "tuvaluandollar"
    ],
    "flagClass": "currency-flag currency-flag-tv",
    "kind": "fiat"
  },
  {
    "code": "TWD",
    "name": "Taiwan New Dollar",
    "symbol": "NT$",
    "countryCode": "tw",
    "country": "Taiwan",
    "aliases": [
      "dollar",
      "new",
      "taiwan",
      "taiwannewdollar"
    ],
    "flagClass": "currency-flag currency-flag-tw",
    "kind": "fiat"
  },
  {
    "code": "TWT",
    "name": "Trust Wallet Token",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "token",
      "trust",
      "trustwallettoken",
      "wallet"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "TZS",
    "name": "Tanzanian Shilling",
    "symbol": null,
    "countryCode": "tz",
    "country": "Tanzania",
    "aliases": [
      "shilling",
      "tanzanian",
      "tanzanianshilling"
    ],
    "flagClass": "currency-flag currency-flag-tz",
    "kind": "fiat"
  },
  {
    "code": "UAH",
    "name": "Ukrainian Hryvnia",
    "symbol": "₴",
    "countryCode": "ua",
    "country": "Ukraine",
    "aliases": [
      "hryvnia",
      "ukrainian",
      "ukrainianhryvnia"
    ],
    "flagClass": "currency-flag currency-flag-ua",
    "kind": "fiat"
  },
  {
    "code": "UGX",
    "name": "Ugandan Shilling",
    "symbol": null,
    "countryCode": "ug",
    "country": "Uganda",
    "aliases": [
      "shilling",
      "ugandan",
      "ugandanshilling"
    ],
    "flagClass": "currency-flag currency-flag-ug",
    "kind": "fiat"
  },
  {
    "code": "UNI",
    "name": "Uniswap",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "uniswap"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "USD",
    "name": "US Dollar",
    "symbol": "$",
    "countryCode": "us",
    "country": "United States",
    "aliases": [
      "america",
      "americandollar",
      "dollar",
      "us",
      "usa",
      "usdollar"
    ],
    "flagClass": "currency-flag currency-flag-us",
    "kind": "fiat"
  },
  {
    "code": "USDC",
    "name": "USDC",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "USDD",
    "name": "USDD",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "decentralizedusd"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "USDP",
    "name": "USDP Stablecoin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "stablecoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "USDT",
    "name": "Tether",
    "symbol": "₮",
    "countryCode": null,
    "aliases": [
      "tether"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "UYU",
    "name": "Uruguayan Peso",
    "symbol": null,
    "countryCode": "uy",
    "country": "Uruguay",
    "aliases": [
      "peso",
      "uruguayan",
      "uruguayanpeso"
    ],
    "flagClass": "currency-flag currency-flag-uy",
    "kind": "fiat"
  },
  {
    "code": "UZS",
    "name": "Uzbekistani Som",
    "symbol": null,
    "countryCode": "uz",
    "country": "Uzbekistan",
    "aliases": [
      "som",
      "uzbekistani",
      "uzbekistanisom"
    ],
    "flagClass": "currency-flag currency-flag-uz",
    "kind": "fiat"
  },
  {
    "code": "VAL",
    "name": "Vatican City Lira",
    "symbol": null,
    "countryCode": "va",
    "country": "Vatican City",
    "aliases": [
      "city",
      "lira",
      "vatican",
      "vaticancitylira"
    ],
    "flagClass": "currency-flag currency-flag-va",
    "kind": "fiat"
  },
  {
    "code": "VEB",
    "name": "Venezuelan Bolívar",
    "symbol": null,
    "countryCode": "ve",
    "country": "Venezuela",
    "aliases": [
      "bol",
      "var",
      "venezuelan",
      "venezuelanbolvar"
    ],
    "flagClass": "currency-flag currency-flag-ve",
    "kind": "fiat"
  },
  {
    "code": "VED",
    "name": "Venezuelan Bolívar Digital",
    "symbol": "Bs.D",
    "countryCode": "ve",
    "country": "Venezuela",
    "aliases": [
      "bol",
      "digital",
      "var",
      "venezuelan",
      "venezuelanbolvardigital"
    ],
    "flagClass": "currency-flag currency-flag-ve",
    "kind": "fiat"
  },
  {
    "code": "VEF",
    "name": "Venezuelan Bolívar",
    "symbol": null,
    "countryCode": "ve",
    "country": "Venezuela",
    "aliases": [
      "bol",
      "var",
      "venezuelan",
      "venezuelanbolvar"
    ],
    "flagClass": "currency-flag currency-flag-ve",
    "kind": "fiat"
  },
  {
    "code": "VES",
    "name": "Venezuelan Bolívar",
    "symbol": null,
    "countryCode": "ve",
    "country": "Venezuela",
    "aliases": [
      "bol",
      "var",
      "venezuelan",
      "venezuelanbolvar"
    ],
    "flagClass": "currency-flag currency-flag-ve",
    "kind": "fiat"
  },
  {
    "code": "VET",
    "name": "Vechain",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "vechain"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "VND",
    "name": "Vietnamese Dong",
    "symbol": "₫",
    "countryCode": "vn",
    "country": "Vietnam",
    "aliases": [
      "dong",
      "vietnamese",
      "vietnamesedong"
    ],
    "flagClass": "currency-flag currency-flag-vn",
    "kind": "fiat"
  },
  {
    "code": "VUV",
    "name": "Ni-Vanuatu Vatu",
    "symbol": null,
    "countryCode": "vu",
    "country": "Vanuatu",
    "aliases": [
      "ni",
      "nivanuatuvatu",
      "vanuatu",
      "vatu"
    ],
    "flagClass": "currency-flag currency-flag-vu",
    "kind": "fiat"
  },
  {
    "code": "WAVES",
    "name": "Waves",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "WEMIX",
    "name": "WEMIX",
    "symbol": null,
    "countryCode": null,
    "aliases": [],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "WOO",
    "name": "WOO Network",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "network"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "WST",
    "name": "Samoan Tala",
    "symbol": null,
    "countryCode": "ws",
    "country": "Samoa",
    "aliases": [
      "samoan",
      "samoantala",
      "tala"
    ],
    "flagClass": "currency-flag currency-flag-ws",
    "kind": "fiat"
  },
  {
    "code": "XAF",
    "name": "Central African CFA Franc BEAC",
    "symbol": null,
    "countryCode": "cm",
    "country": "Cameroon",
    "aliases": [
      "african",
      "beac",
      "central",
      "centralafricancfafrancbeac",
      "cfa",
      "franc"
    ],
    "flagClass": "currency-flag currency-flag-cm",
    "kind": "fiat"
  },
  {
    "code": "XAG",
    "name": "Silver Ounce",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "ounce",
      "silver",
      "silverounce"
    ],
    "flagClass": null,
    "kind": "metal"
  },
  {
    "code": "XAU",
    "name": "Gold Ounce",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "gold",
      "goldounce",
      "ounce"
    ],
    "flagClass": null,
    "kind": "metal"
  },
  {
    "code": "XAUT",
    "name": "Tether Gold",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "gold",
      "tether",
      "tethergold"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "XBT",
    "name": "Bitcoin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "bitcoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "XCD",
    "name": "East Caribbean Dollar",
    "symbol": null,
    "countryCode": "ag",
    "country": "Antigua and Barbuda",
    "aliases": [
      "caribbean",
      "dollar",
      "east",
      "eastcaribbeandollar"
    ],
    "flagClass": "currency-flag currency-flag-ag",
    "kind": "fiat"
  },
  {
    "code": "XCG",
    "name": "Xchange",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "xchange"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "XCH",
    "name": "Chia",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "chia"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "XDC",
    "name": "XDC Network",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "network"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "XDR",
    "name": "IMF Special Drawing Rights",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "drawing",
      "imf",
      "imfspecialdrawingrights",
      "rights",
      "special"
    ],
    "flagClass": null,
    "kind": "other"
  },
  {
    "code": "XEC",
    "name": "Eternal Coin",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "coin",
      "eternal",
      "eternalcoin"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "XEM",
    "name": "NEM",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "nem"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "XLM",
    "name": "Stellar Lumen",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "lumen",
      "stellar",
      "stellarlumen"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "XMR",
    "name": "Monero",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "monero"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "XOF",
    "name": "CFA Franc",
    "symbol": null,
    "countryCode": "sn",
    "country": "Senegal",
    "aliases": [
      "cfa",
      "cfafranc",
      "franc"
    ],
    "flagClass": "currency-flag currency-flag-sn",
    "kind": "fiat"
  },
  {
    "code": "XPD",
    "name": "Palladium Ounce",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "ounce",
      "palladium",
      "palladiumounce"
    ],
    "flagClass": null,
    "kind": "metal"
  },
  {
    "code": "XPF",
    "name": "CFP Franc",
    "symbol": null,
    "countryCode": "pf",
    "country": "French Polynesia",
    "aliases": [
      "cfp",
      "cfpfranc",
      "franc"
    ],
    "flagClass": "currency-flag currency-flag-pf",
    "kind": "fiat"
  },
  {
    "code": "XPT",
    "name": "Platinum Ounce",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "ounce",
      "platinum",
      "platinumounce"
    ],
    "flagClass": null,
    "kind": "metal"
  },
  {
    "code": "XRP",
    "name": "Ripple",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "ripple"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "XTZ",
    "name": "Tezos",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "tezos"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "YER",
    "name": "Yemeni Rial",
    "symbol": "﷼",
    "countryCode": "ye",
    "country": "Yemen",
    "aliases": [
      "rial",
      "yemeni",
      "yemenirial"
    ],
    "flagClass": "currency-flag currency-flag-ye",
    "kind": "fiat"
  },
  {
    "code": "ZAR",
    "name": "South African Rand",
    "symbol": "R",
    "countryCode": "za",
    "country": "South Africa",
    "aliases": [
      "african",
      "rand",
      "south",
      "southafricanrand"
    ],
    "flagClass": "currency-flag currency-flag-za",
    "kind": "fiat"
  },
  {
    "code": "ZEC",
    "name": "ZCash",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "zcash"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ZIL",
    "name": "Zilliqa",
    "symbol": null,
    "countryCode": null,
    "aliases": [
      "zilliqa"
    ],
    "flagClass": null,
    "kind": "crypto"
  },
  {
    "code": "ZMK",
    "name": "Zambian Kwacha",
    "symbol": null,
    "countryCode": "zm",
    "country": "Zambia",
    "aliases": [
      "kwacha",
      "zambian",
      "zambiankwacha"
    ],
    "flagClass": "currency-flag currency-flag-zm",
    "kind": "fiat"
  },
  {
    "code": "ZMW",
    "name": "Zambian Kwacha",
    "symbol": null,
    "countryCode": "zm",
    "country": "Zambia",
    "aliases": [
      "kwacha",
      "zambian",
      "zambiankwacha"
    ],
    "flagClass": "currency-flag currency-flag-zm",
    "kind": "fiat"
  },
  {
    "code": "ZWD",
    "name": "Zimbabwean Dollar",
    "symbol": null,
    "countryCode": "zw",
    "country": "Zimbabwe",
    "aliases": [
      "dollar",
      "zimbabwean",
      "zimbabweandollar"
    ],
    "flagClass": "currency-flag currency-flag-zw",
    "kind": "fiat"
  },
  {
    "code": "ZWG",
    "name": "Zimbabwe Gold",
    "symbol": "ZiG",
    "countryCode": "zw",
    "country": "Zimbabwe",
    "aliases": [
      "gold",
      "zimbabwe",
      "zimbabwegold"
    ],
    "flagClass": "currency-flag currency-flag-zw",
    "kind": "fiat"
  },
  {
    "code": "ZWL",
    "name": "Zimbabwean Dollar",
    "symbol": null,
    "countryCode": "zw",
    "country": "Zimbabwe",
    "aliases": [
      "dollar",
      "zimbabwean",
      "zimbabweandollar"
    ],
    "flagClass": "currency-flag currency-flag-zw",
    "kind": "fiat"
  }
];
